import React from "react";
import PropTypes from "prop-types";
import { parseMessage, createMarkup, createAnchor } from "../utils/parser";

const ExtraMessage = (props) => {
  let message = props.extraMessage.message;
  let finalDate = props.dtime;
  let customStyles = props.style;
  if (undefined !== message) {
    const showAncButton = props.showAncButton;
    let messages = { text: "", html: "", orignMessage: "" };
    if (!showAncButton) messages = parseMessage(message, showAncButton);
    let ShowDate = ``;
    let lmore = "",
      lmoreClass = "date-more";
    if (props.currentIndex === props.extraChatsCount - 1) {
      ShowDate = `${finalDate}`;
      lmore = props.lmore;
      if (lmore !== "") lmoreClass = "learn-more-date";
    }
    if (showAncButton) {
      messages.html = createAnchor(props.extraMessage.message);
      if (!messages.html) {
        const danglingCtaMatch = props.extraMessage.message.match(
          /target\s*=\s*"_blank"[^>]*>([^<\n]+)/i
        );
        if (danglingCtaMatch) {
          const ctaLabel = (danglingCtaMatch[1] || "Schedule Appointment").trim();
          const fallbackHrefMatch = (lmore || "").match(/href="([^"]+)"/i);
          if (fallbackHrefMatch && fallbackHrefMatch[1]) {
            messages.html = `<a href="${fallbackHrefMatch[1]}" target="_blank">${ctaLabel}</a>`;
          }
        }
      }
      const messageWithoutAnchor = props.extraMessage.message
        .replace(/<a\b[\s\S]*?<\/a>/i, "")
        .replace(/(?<!["'=])(https?:\/\/[^\s"<>]+)\s*"\s*[^>]*>[^<\n]+/i, "")
        .replace(/target\s*=\s*"_blank"[^>]*>[^<\n]+/i, "")
        .trim();
      messages.orignMessage = messageWithoutAnchor;
      messages.text = messageWithoutAnchor;
    }
    if (messages.html === "") {
      if (props.bot.cssTheme === "option2") {
        //console.log("date-div 1");
        //console.log(customStyles);

        return (
          <div class="date-div">
            <div className="chat-text" style={customStyles}>
              <p
                dangerouslySetInnerHTML={createMarkup(
                  messages.orignMessage,
                  ""
                )}
              />
            </div>
            <div className={lmoreClass}>
              {messages.showCancelLink ? (
                <span>
                  <button onClick={props.handleClick} type="button" style={{background: 'none', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer', padding: 0}}>
                    Never Mind
                  </button>
                  &nbsp;
                </span>
              ) : (
                ""
              )}
              <span dangerouslySetInnerHTML={createMarkup(lmore, "")} />
              {ShowDate}
            </div>
          </div>
        );
      } else {
        //console.log("date-div 2");
        return (
          <div className="chat-text" style={customStyles}>
            <p
              dangerouslySetInnerHTML={createMarkup(messages.orignMessage, "")}
            />
            <b>{ShowDate}</b>
          </div>
        );
      }
    } else {
      if (props.bot.cssTheme === "option2") {
        let btnMrkup = ``;
        if (messages.html.includes('type="qrb"')) {
          btnMrkup = createMarkup(messages.html, customStyles); // CTA style
        } else {
          const html = messages.html.replace(
            /type="button"/g,
            'type="button" style="font-weight:100;"'
          );
          btnMrkup = createMarkup(html, ""); // without custom styling
        }
        if (messages.text.includes("<a")) {
          const startIndex = messages.text.indexOf("<a");
          const lastIndex = messages.text.lastIndexOf("</a>");
          const searchVal = messages.text.substring(
            startIndex + 9,
            lastIndex + 4
          );
          messages.text = messages.text.replace(searchVal, "");
        }
        //console.log('props.extraMessage.message props.extraMessage.message props.extraMessage.message',messages.text);

        return (
          <div class="date-div">
            <div className="chat-text test" style={customStyles}>
              <p
                dangerouslySetInnerHTML={createMarkup(
                  messages.text,
                  customStyles
                )}
              />
            </div>
            <br />
            <div className={lmoreClass}>
              {messages.showCancelLink ? (
                <span>
                  <button onClick={props.handleClick} type="button" style={{background: 'none', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer', padding: 0}}>
                    Never Mind
                  </button>
                  &nbsp;
                </span>
              ) : (
                ""
              )}
              <span dangerouslySetInnerHTML={createMarkup(lmore, "")} />
              {ShowDate}
            </div>
            <div className="button-include">
              <div
                onClick={props.handleClick}
                className="quick_reply"
                dangerouslySetInnerHTML={btnMrkup}
              />
            </div>
          </div>
        );
      } else {
        return (
          <div className="button-include">
            <div className="chat-text">
              <p
                dangerouslySetInnerHTML={createMarkup(
                  messages.text,
                  customStyles
                )}
              />{" "}
              <b>{ShowDate}</b>
            </div>
            <div
              onClick={props.handleClick}
              className="quick_reply"
              dangerouslySetInnerHTML={createMarkup(messages.html)}
            />
          </div>
        );
      }
    }
  } else return "";
};

ExtraMessage.propTypes = {
  message: PropTypes.string,
  author: PropTypes.string,
  props: PropTypes.object,
};

export default ExtraMessage;

//15 hours to add
